import { render, staticRenderFns } from "./MonthlyPerfomance.vue?vue&type=template&id=82083e4c&scoped=true&"
import script from "./MonthlyPerfomance.vue?vue&type=script&lang=js&"
export * from "./MonthlyPerfomance.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyPerfomance.vue?vue&type=style&index=0&id=82083e4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82083e4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
